<template>
  <div style="height:100%">
    <div
      v-if="!localSelectedTradingId"
      class="flex flex-col align-center"
      :class="{
          'justify-center': !newFlag,
          'justify-start': newFlag
      }"
      style="height:100%"
    >
      <!-- 取引新規作成 -->
      <div v-if="newFlag" style="width:100%;" class="self-start">
        <div class="mb-4">
          <el-button size="mini" type="text" @click="handleCancel">
            {{ `< Back` }}
          </el-button>
        </div>
        <TwAddTrading />
      </div>

      <div v-else>
        <el-image src="/images/map.png" style="opacity:0.8" fit="contain" />
      </div>
    </div>
    <div v-else class="trading-flow-list">
      <!-- 取引新規作成 -->
      <div v-if="newFlag">
        <div class="mb-4">
          <el-button size="mini" type="text" @click="handleCancel">
            {{ `< Back` }}
          </el-button>
        </div>
        <TwAddTrading />
      </div>

      <!-- 取引フロー一覧 -->
      <div v-else-if="targetTrading">
        <div class="flex align-start">
          <div class="flex-grow text-12 text-gray-350">
            {{ lang === 'ja' ? 'フロー一覧' : 'Flow List' }}
          </div>
          <div class="text-10 text-gray-350 copyable">
            ID: {{ targetTrading.tradingId }}
          </div>
        </div>

        <div class="flex flex-row align-center pt-2 pb-3 px-1">
          <div class="flex-grow">
            <div
              v-if="!editTradingNameMode"
              class="text-18 text-bold text-gray-800 mb-2"
            >
              <div
                class="flex align-center"
              >
                <div
                  v-if="targetTrading.tradingSubmitStatusCd === 1"
                  class="draft text-16 mr-2"
                >
                  Draft
                </div>
                <div class="copyable">
                  {{ targetTrading.tradingName }}
                  <i
                    class="el-icon-edit cursor-pointer"
                    style="color:#5185C5;"
                    v-if="canEditFlow"
                    @click="editTradingNameMode = true"
                  />
                </div>
              </div>
            </div>
            <div v-else>
              <el-form
                :model="formTrading"
                ref="formComponent"
                class="flex-grow"
                :rules="rules"
              >
                <el-form-item prop="tradingName">
                  <el-input
                    style="width: 350px"
                    v-model="formTrading.tradingName"
                    @input="$emit('dirty')"
                    show-word-limit
                    maxlength="100"
                  />
                </el-form-item>
              </el-form>
            </div>
            <div class="text-12 mb-1 text-gray-400">
              Owner:<span class="text-gray-600 ml-2">{{
                targetTrading.companyName
              }}</span>
            </div>
          </div>
          <div v-if="canAddNewFlow" class="mb-1">
            <el-button
              v-if="
                !editTradingNameMode &&
                  targetTrading.tradingSubmitStatusCd !== 1 &&
                  (!isFwd || isOwnerFlg)
              "
              type="primary"
              icon="el-icon-plus"
              size="mini"
              @click="onCreate"
              data-gtm="plus_flow_click"
            >
              <!-- 新規フロー作成 -->
              Flow
            </el-button>
            <div
              v-else-if="editTradingNameMode && canEditFlow"
              class="flex align-center"
            >
              <!-- 取引名の編集保存 -->
              <el-button
                type="default"
                size="mini"
                @click="editTradingNameMode = false"
              >
                Cancel
              </el-button>
              <el-button
                v-if="targetTrading.tradingSubmitStatusCd === 1"
                type="primary"
                size="mini"
                @click="handleSubmit('save')"
              >
                Save
              </el-button>
              <el-button
                v-if="targetTrading.tradingSubmitStatusCd !== 1"
                type="primary"
                size="mini"
                @click="handleSubmit('register')"
              >
                Register
              </el-button>
            </div>
          </div>
        </div>

        <div class="flex align-end pb-4">
          <TwTableFilterBar
            class="flex-grow"
            isFixedDialog
            :filterSchema="filterSchema"
            :filterModel="filterForm"
            :filterChips="filterChips"
            @apply="onApply"
            @remove="removeFilter"
            @reset="resetFilters"
          />
          <div>
            <el-dropdown trigger="click" placement="bottom" @command="handleClickMenu" :tabindex="-1">
              <tw-button class="menu_button" type="secondary" size="small" icon="menu">{{ $t('Label.View Options') }}</tw-button>
              <el-dropdown-menu class="nowrap">
                <el-dropdown-item command="changeDisplayColumn">{{ $t('Label.Column Preference') }}</el-dropdown-item>
                <el-dropdown-item :command="modeChangeWidth ? 'saveWidthColumn' : 'changeWidthColumn'">{{ modeChangeWidth ? $t('Label.Complete Width Edit Mode') : $t('Label.Column Width') }}</el-dropdown-item>
                <el-dropdown-item command="resetDisplayColumn">{{ $t('Label.Reset Column') }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <tw-button
              type="secondary"
              size="small"
              style="margin-left: 10px"
              @click="tsvDownLoadClick"
            >
              {{ $t('Label.TSV Download') }}
            </tw-button>
          </div>
        </div>
        <TwTable
          :cols="visibleSchemas"
          :tableData="data ? tradingList : []"
          :editMode="false"
          :offsetY="293"
          :loading="loading"
          :border="modeChangeWidth"
          @sort-changed="sortChange"
          @click-row="rowClick"
          @column-width-changed="handleColumnWidthChange"
        />
        <TwPagination
          v-if="data"
          :lang="lang"
          :total="data.totalCount"
          :pageSize="pageSize"
          :currentPage="currentPage"
          @page-changed="changePage"
          @size-changed="changeSize"
        />

        <TwTableColumnSettingDialog
          :full-schemas="tradingFlowListTableSchema"
          :show-schemas.sync="visibleSchemas"
          :visible.sync="isOpenTableSettingDialog"
          @close="updateColumnSetting"
        />
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import {
  defineComponent,
  ref,
  watch,
  computed,
  reactive,
  getCurrentInstance,
  onMounted,
  nextTick,
} from '@vue/composition-api';

import {
  API_USE_CODE,
  FROM_TO_TYPE,
  LANGUAGE_CODE,
  ABLE_FLG,
} from 'lib-tw-common';
import { $api } from '@/store/ApiClient';
import { useLakeelValidation } from '@/composables/useLakeelValidation';
import {
  sectionForPulldown,
  initialFlag,
  formatUtcDate,
  getYMDStartDate,
  getYMDEndDate,
  forcedCloseNotHiddenOnly,
  forcedCloseConvertFromCheckbox,
} from '@/utils/searchUtil';

// schema
import schemas from '@/dictionaries/vue3/tradingListTsvSchema.json';
import { tradingFlowListTableSchema } from '@/dictionaries/vue3/tradingList/tradingFlowListTableSchema';
import { tradingFlowListFilterSchema } from '@/dictionaries/vue3/tradingList/tradingFlowListFilterSchema';

import { useBffTradingSearch } from '@/composables/useBffTradingSearch';
import { useFilterSchema } from '@/composables/useFilterSchema';
import { useBffTradingManagesEditor } from '@/composables/useBffTradingManagesEditor';

import {
  convertFilterFormToQuery,
  convertSortEventToQuery,
} from '@/utils/filterUtil';
import { tsvDownLoad } from '@/utils/listToTsvUtils.js';
import { MAX_TRADING_FLOW_COUNT } from '@/utils/constants';

// import { ownerSection, sectionIds } from '@/sampleData/store';

import TwTableColumnSettingDialog from '@/components/organisms/TwTableColumnSettingDialog.vue';
import TwButton from '@/components/atoms/TwButton.vue';

// components
import TwTableFilterBar from '@/components/vue3/TwTableFilterBar.vue';
import TwTable from '@/components/vue3/TwTable.vue';
import TwPagination from '@/components/vue3/TwPagination.vue';

import TwAddTrading from './newTrading.vue';
import TradingFlowFilter from './TradingFlowFilter.vue';

export default defineComponent({
  name: 'TradingFlowList',
  components: {
    TwButton,
    TwAddTrading,
    TwTableFilterBar,
    TwTable,
    TwPagination,
    TradingFlowFilter,
    TwTableColumnSettingDialog,
  },
  props: {
    selectedTradingId: {
      type: String,
      required: true,
    },
    targetTrading: {
      type: Object,
      default: () => {},
    },
    newFlag: {
      type: Boolean,
      default: () => false,
    },
    canAddNewFlow: {
      type: Boolean,
      default: false,
    },
    isOwnerFlg: {
      type: Boolean,
      default: false,
    },
    onToggleCollapse: {
      type: Function,
      default: () => {},
    },
    flowUpdateDatetime: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { root, emit }) {
    // TODO: vue3時に書き換え
    const vm = getCurrentInstance().proxy;
    const tableId = 'TradingFlowList';

    const language = root.$store.state.locale;
    const lang = _.get(LANGUAGE_CODE, `${language}`, 'ja');

    const localSelectedTradingId = ref(props.selectedTradingId);

    const currentPage = ref(1);
    const pageSize = ref(20);
    const sort = ref(null);
    const isOpenTableSettingDialog = ref(false);
    const filteredSchemas = ref([]);
    const visibleSchemas = ref([]);
    const modeChangeWidth = ref(false);

    const canEditFlow = ref(false);
    const editTradingNameMode = ref(false);
    const formTrading = reactive({ tradingName: '' });
    const formComponent = ref(null);

    const cloneTradingListSchema = _.cloneDeep(tradingFlowListTableSchema)

    const { onEventValidation, validationCheck } = useLakeelValidation(
      root.$store,
      formTrading,
      formComponent,
    );

    const rules = {
      tradingName: [
        {
          lakeelMessageSourceFlg: true,
          validationId: 'tw-isMaxLength100',
          validator: onEventValidation,
          trigger: 'blur',
          field: 'tradingName',
          label: 'tradingName',
        },
      ],
    };

    // offset計算
    const offset = computed(() => (currentPage.value - 1) * pageSize.value);

    const isShipper = computed(() => {
      // カンパニーロールが荷主か
      return root.$store.getters.isShipper;
    });

    const isFwd = computed(() => {
      return root.$store.getters.isFwd;
    });

    const isPic = computed(() => {
      return root.$store.state.userInformationV2?.picFlg;
    })

    const {
      form: filterForm,
      chips: filterChips,
      filterSchema,
      updateOptions,
      setFormValues,
    } = useFilterSchema(
      tradingFlowListFilterSchema,
      // 「非表示フロー含む」は未操作時も明示的にfalse(=forcedClose:0で非表示フローを除外)とする。
      // useFilterSchemaはフォーム初期化時にスキーマのdefaultを参照しないため、ここで初期値を渡す必要がある。
      // src\utils\searchUtil.jsの【取引一覧のforcedClose補足】参照。
      { forcedCloseIncludeHiddenFlow: false },
      root.$t.bind(root),
    )

    const companyId = computed(() => {
      return root.$store.state.companyId;
    });

    // vue3ではuseStoreにする必要あり
    const ownerSectionLists = computed(
      () => root.$store.getters.getOwnerSectionLists,
    );

    updateOptions('ownerSectionIds', ownerSectionLists.value);

    watch(ownerSectionLists, newVal => {
      updateOptions('ownerSectionIds', newVal);
    });

    let firstFetchDone = false;
    const formQueries = convertFilterFormToQuery(filterForm);
    const queries = computed(() => {
      formQueries.forcedClose = forcedCloseNotHiddenOnly(formQueries); // 右ペインのフロ一覧(TradingFlowList.vue)での設定。src\utils\searchUtil.jsの【取引一覧のforcedClose補足】参照。
      return {
        ...formQueries,
        tradingId: props.selectedTradingId || '',
        initialFlag: initialFlag(formQueries),
        limit: pageSize.value,
        offset: offset.value,
        sort: sort.value,
        apiUseCode: API_USE_CODE.TRADING_LIST,
      };
    });

    // BFFから情報取得
    const { data, tradingList, loading, error, refresh } = useBffTradingSearch(
      queries.value,
    );

    watch(error, err => {
      if (err && !err.isCanceled) {
        root.$store.dispatch('SHOW_ALERT', err.message);
      }
    });

    // 取引名編集用
    const managesEditorParams = {
      path: { companyId: companyId.value },
      queries: {},
      immediate: false,
      tradingFlowId: '',
    };

    const {
      loading: editorLoading,
      forbidden,
      tradingInfo: editorTradingInfo,
      fetchData: fetchEditData,
    } = useBffTradingManagesEditor(managesEditorParams);

    watch(
      filterForm,
      newVal => {
        filteredSchemas.value = filterSchema.value;
      },
      { deep: true, immediate: true },
    );

    // SelectableTradingList側で指定された更新日時条件を、TradingFlowList自身のlastUpdateDatetimeの入力有無に関わらず反映する
    watch(
      () => props.flowUpdateDatetime,
      newVal => {
        if (newVal?.[0] || newVal?.[1]) {
          setFormValues({ lastUpdateDatetime: newVal });
          onApply();
        }
      },
      { immediate: true },
    );

    watch(
      () => props.selectedTradingId,
      (newId, oldId) => {
        localSelectedTradingId.value = newId || '';
        if (newId && newId !== oldId) {
          // editTradingNameMode.value = false;
          // isHoveredTradingName.value = false;
          currentPage.value = 1;
          if (filterChips.value.length > 0) {
            onApply();
          } else {
            refresh(queries.value);
          }
        }
      },
    );

    watch(
      () => props.targetTrading,
      (newVal, oldVal) => {
        if (newVal && newVal !== oldVal) {
          localSelectedTradingId.value = newVal.tradingId || '';
          editTradingNameMode.value = false;
          formTrading.tradingName = newVal?.tradingName;
          if ((isShipper.value || isPic.value || isFwd.value) && !forbidden.value) {
            fetchEditData({
              queries: {
                tradingId: localSelectedTradingId.value,
              },
            });
          }
        }
      },
    );

    watch(editorTradingInfo, newVal => {
      canEditFlow.value =
        newVal.tradingPatternInfo && newVal.canAddNewFlowFlg === ABLE_FLG.TRUE;
    });

    const getSection = fromTo => {
      const query = {
        entityType: undefined,
        processId: null,
        fromToFlg: fromTo,
        deleteType: 0,
      };

      root.$store
        .dispatch('GET_SECTIONS', query)
        .then(res => {
          if (fromTo === FROM_TO_TYPE.FROM) {
            updateOptions(
              'fromSectionIds',
              sectionForPulldown(res.customerSectionList),
            );
          } else {
            updateOptions(
              'toSectionIds',
              sectionForPulldown(res.customerSectionList),
            );
          }
        })
        .catch(err => {
          root.$store.dispatch('SHOW_ALERT', err.message);
        });
    };

    const onApply = () => {
      currentPage.value = 1;
      const newQuery = convertFilterFormToQuery(filterForm);
      const queries = {
        ...newQuery,
        tradingId: props.selectedTradingId || '',
        initialFlag: initialFlag(formQueries),
        limit: pageSize.value,
        offset: offset.value,
        sort: sort.value,
        apiUseCode: API_USE_CODE.TRADING_LIST,
      };
      refresh(queries);
    };

    const removeFilter = key => {
      const target = filterSchema.value.find(item => item.key === key);
      if (!target) return;
      filterForm[key] =
        target.type === 'daterange'
          ? ['', '']
          : target.type === 'checkbox'
            ? false
            : target.default !== undefined
              ? target.default
              : '';
      onApply();
    };

    const resetFilters = () => {
      filterSchema.value.forEach(item => {
        if (item.key === 'lastUpdateDatetime') return;
        filterForm[item.key] =
          item.type === 'daterange'
            ? ['', '']
            : item.type === 'checkbox'
              ? false
              : item.default !== undefined
                ? item.default
                : '';
      });
      // 更新ボタン押下時はSelectableTradingList側の最終更新日時に同期する
      if (props.flowUpdateDatetime?.[0] || props.flowUpdateDatetime?.[1]) {
        setFormValues({ lastUpdateDatetime: [...props.flowUpdateDatetime] });
      }
      onApply();
    };

    const changePage = page => {
      currentPage.value = page;
      const query = {
        ...convertFilterFormToQuery(filterForm),
        tradingId: props.selectedTradingId || '',
        initialFlag: initialFlag(filterForm),
        limit: pageSize.value,
        offset: offset.value,
        sort: sort.value,
        apiUseCode: API_USE_CODE.TRADING_LIST,
      };
      refresh(query);
    };

    const changeSize = size => {
      currentPage.value = 1
      pageSize.value = size;
      const query = {
        ...convertFilterFormToQuery(filterForm),
        tradingId: props.selectedTradingId || '',
        initialFlag: initialFlag(filterForm),
        limit: pageSize.value,
        offset: offset.value,
        sort: sort.value,
        apiUseCode: API_USE_CODE.TRADING_LIST,
      };
      refresh(query);
    };

    const sortChange = sortEvent => {
      const sortQuery = convertSortEventToQuery(sortEvent);
      sort.value = sortQuery;
      const query = {
        ...convertFilterFormToQuery(filterForm),
        tradingId: props.selectedTradingId || '',
        initialFlag: initialFlag(filterForm),
        limit: pageSize.value,
        offset: offset.value,
        sort: sortQuery,
        apiUseCode: API_USE_CODE.TRADING_LIST,
      };
      refresh(query);
    };

    const handleClickMenu = async command => {
      if (command === 'changeDisplayColumn') {
        isOpenTableSettingDialog.value = true;
      }
      if (command === 'changeWidthColumn') {
        modeChangeWidth.value = true;
      }
      if (command === 'saveWidthColumn') {
        modeChangeWidth.value = false;
        setTableSetting();
      }
      if (command === 'resetDisplayColumn') {
        modeChangeWidth.value = false;
        visibleSchemas.value = [...cloneTradingListSchema]
        setTableSetting();
      }
    };

    const tsvDownLoadClick = async () => {
      const items = await fetchAll();
      const filteredSchemas = schemas.filter(
        item => item.key !== 'entityStatus',
      );
      tsvDownLoad(filteredSchemas, items);
    }

    const setTableSetting = () => {
      if (tableId === undefined) return;
      root.$store.commit('SET_TABLE_SETTING', {
        tableId,
        tableSetting: { schemas: visibleSchemas.value },
      });
    };

    const updateColumnSetting = async items => {
      visibleSchemas.value.splice(0, visibleSchemas.value.length);
      nextTick(() => {
        visibleSchemas.value = [...items];
        setTableSetting();
      });
    };

    const rowClick = item => {
      props.onToggleCollapse(true);
      const path = `/trading/process/${item.tradingId}/${item.tradingFlowId}/`;
      vm.$router.push(path);
      // vm.$router.push(`/v3/trading/${item.tradingId}/`);
      // alert(`${item.tradingId}/${item.tradingFlowId}の情報を開く`);
    };

    // 取引フロー上限到達時のダイアログを表示します
    const showFlowLimitDialog = () => {
      root.$store
        .dispatch('SHOW_CONFIRM_CUSTOM', {
          message: root.$t('Message.FlowCountLimitReached', {
            max: MAX_TRADING_FLOW_COUNT,
          }),
          confirmButtonText: root.$t('Label.Create New Trading'),
          cancelButtonText: root.$t('Label.Close'),
        })
        .then(() => root.$router.push('/trading/new/'))
        .catch(() => {});
    };

    const onCreate = async () => {
      let count;
      try {
        count = await fetchCurrentFlowCount();
      } catch (err) {
        root.$store.dispatch(
          'SHOW_ALERT',
          root.$t('Message.ERROR__FLOW_COUNT_CHECK_FAILED'),
        );
        return;
      }
      if (count >= MAX_TRADING_FLOW_COUNT) {
        showFlowLimitDialog();
        return;
      }
      const path = `/trading/process/${props.selectedTradingId}/new`;
      vm.$router.push(path);
    };

    const handleCancel = () => {
      emit('cancel');
    };

    // 指定したオブジェクトの中身を一階層上に展開
    const flatten = (ary, target) => {
      return _.map(ary, o => {
        return { ..._.omit(o, [target]), ...o.linkageInfo };
      });
    };

    // POSTパラメータを生成します
    const transformQueries = () => {
      const f = filterForm;
      const targetTradingInfo = _.find(tradingList.value, {
        tradingId: localSelectedTradingId.value,
      });

      const queries = {
        flowUpdateDateFrom: f.lastUpdateDatetime
          ? formatUtcDate(f.lastUpdateDatetime[0])
          : null,
        flowUpdateDateTo: f.lastUpdateDatetime?.[1]
          ? formatUtcDate(f.lastUpdateDatetime[1]).replace('00Z', '59Z')
          : null,
        tradingProgressStatus: f.tradingProgressStatus,
        tradingName: f.tradingName,
        flowName: f.flowName,
        invoiceNo: f.invoiceNo,
        flowCreateDateFrom: f.flowCreateDatetime
          ? formatUtcDate(f.flowCreateDatetime[0])
          : null,
        flowCreateDateTo: f.flowCreateDatetime?.[1]
          ? formatUtcDate(f.flowCreateDatetime[1]).replace('00Z', '59Z')
          : null,
        fromSectionIds: f.fromSectionIds,
        toSectionIds: f.toSectionIds,
        tradingId: targetTradingInfo.tradingId,
        tradingFlowId: filterForm.tradingFlowId,
        contractDateStartDate: getYMDStartDate(f.contractDate),
        contractEndDate: getYMDEndDate(f.contractDate),
        sellerName: f.sellerName,
        buyerName: f.buyerName,
        goodsName: f.goodsName,
        ownerSectionIds: f.ownerSectionIds,
        nameOfVessel: f.vesselName,
        blNo: f.blNo,
        vesselBookingNo: f.bookingNo,
        blDateFrom: getYMDStartDate(f.etdBlDate),
        blDateTo: getYMDEndDate(f.etdBlDate),
        dischargingCurrentEtaFrom: getYMDStartDate(f.currentEta),
        dischargingCurrentEtaTo: getYMDEndDate(f.currentEta),
        portOfLoadingName: f.portOfLoading,
        portOfDischargingName: f.portOfDischarging,
        imRequestDeclarationDateFrom: getYMDStartDate(
          f.imRequestDeclarationDate,
        ),
        imRequestDeclarationDateTo: getYMDEndDate(f.imRequestDeclarationDate),
        deliveryDateFrom: getYMDStartDate(f.deliveryDate),
        deliveryDateTo: getYMDEndDate(f.deliveryDate),
        devanningPlace: f.devanningPlace,
        warehouse: f.warehouse,
        freeTimeFrom: getYMDStartDate(f.freeTime),
        freeTimeTo: getYMDEndDate(f.freeTime),
        exRequestDeclarationDateFrom: getYMDStartDate(
          f.exRequestDeclarationDate,
        ),
        exRequestDeclarationDateTo: getYMDEndDate(f.exRequestDeclarationDate),
        vanningDateFrom: getYMDStartDate(f.vanningDate),
        vanningDateTo: getYMDEndDate(f.vanningDate),
        vanningPlace: f.vanningPlace,
        cyCutDateFrom: getYMDStartDate(f.cyCutDate),
        cyCutDateTo: getYMDEndDate(f.cyCutDate),
        poNo: f.poNo,
        loadingPortCurrentEtdFrom: getYMDStartDate(f.loadingPortCurrentEtd),
        loadingPortCurrentEtdTo: getYMDEndDate(f.loadingPortCurrentEtd),
        loadingPortAtdFrom: getYMDStartDate(f.loadingPortAtd),
        loadingPortAtdTo: getYMDEndDate(f.loadingPortAtd),
        dischargingAtaFrom: getYMDStartDate(f.dischargingAta),
        dischargingAtaTo: getYMDEndDate(f.dischargingAta),
        scheduledDeliveryDateFrom: getYMDStartDate(f.scheduledDeliveryDate),
        scheduledDeliveryDateTo: getYMDEndDate(f.scheduledDeliveryDate),
        scheduledDevanningDateFrom: getYMDStartDate(f.scheduledDevanningDate),
        scheduledDevanningDateTo: getYMDEndDate(f.scheduledDevanningDate),
        modeOfTransportation: f.modeOfTransportation,
        typeOfServiceFrom: f.typeOfServiceFrom,
        hazardousFlag: f.hazardousFlag,
        flowReference: f.flowReference,
        flowUserName: f.flowUserName,
        forcedClose: forcedCloseConvertFromCheckbox(f.forcedCloseIncludeHiddenFlow), // src\utils\searchUtil.jsの【取引一覧のforcedClose補足】参照。
      };

      return {
        ...queries,
        initialFlag: initialFlag(queries),
        limit: pageSize.value,
        offset: offset.value,
        sort: sort.value,
        apiUseCode: API_USE_CODE.TRADING_LIST,
      };
    };

    const fetchIteration = async query => {
      // bff_td_1 取引一覧検索BFF
      const params = {
        lslConfig: {
          serviceCode: 'tw-transaction-bff-api',
          apiCode: 'get_/v1/tradings/search',
          query: query,
        },
      };
      try {
        return await $api.request(params);
      } catch (err) {
        throw err;
      }
    };

    // 現在の取引フロー件数を取得します
    const fetchCurrentFlowCount = async () => {
      // 取引一覧検索(get_/v1/tradings/search)は期間未指定時にBFFが直近N日(既定180日)を補完し、
      // totalCountが「直近N日に更新されたフロー数」になるため件数取得には使わない。
      // 旧取引管理・フロー登録画面(DetailAddFlow)と同じ取引管理検索BFFから全期間の総数を取得する。
      const params = {
        lslConfig: {
          serviceCode: 'tw-transaction-bff-api',
          apiCode: 'get_/v1/tradings/manages/search',
          query: {
            tradingId: props.selectedTradingId || '',
          },
        },
      };
      const res = await $api.request(params);
      return res.tradingInfo.totalTradingFlowCount || 0;
    };

    // TSVダウンロード用に全件取得します
    const fetchAll = () => {
      return new Promise(async (resolve, reject) => {
        let totalCount = 0;
        let items = [];
        const limit = 200;
        const query = { ...transformQueries(), offset: 0, limit: 0 };
        const key = 'TRADING_LIST';
        const id = new Date().getTime().toString();
        root.$store.dispatch('SET_DOWNLOAD_STATUS', {
          key,
          downloadStatus: { id, message: '0%' },
        });
        try {
          const res = await fetchIteration(query);
          totalCount = res.totalCount;
          while (items.length < totalCount) {
            // 0%の時は1件にする。それ以外は進捗率を表示
            const message = `${Math.min(
              Math.floor((items.length / totalCount) * 100),
              100,
            )}%`;
            root.$store.dispatch('SET_DOWNLOAD_STATUS', {
              key,
              downloadStatus: { id, message },
            });
            const res = await fetchIteration({ ...query, limit });
            items = items.concat(flatten(res.tradingFlowList, 'linkageInfo'));
            query.offset += limit;
          }
          root.$store.dispatch('SET_DOWNLOAD_STATUS', {
            key,
            downloadStatus: { id, message: '' },
          });
          resolve(items);
        } catch (err) {
          root.$store.dispatch('SET_DOWNLOAD_STATUS', {
            key,
            downloadStatus: { id, message: '' },
          });
          root.$store.dispatch('SHOW_ALERT', err.message);
          reject();
        }
      });
    };

    const handleSubmit = async action => {
      const apiCode =
        action === 'save'
          ? 'post_/v1/tradings/{companyId}/manages/wk'
          : 'post_/v1/tradings/{companyId}/manages';

      root.$store.commit('START_PROCESS');

      const result = await validationCheck();
      if (!result) {
        root.$store.commit('END_PROCESS');
        root.$store.dispatch(
          'SHOW_ALERT',
          root.$t('Message.ERROR__INPUT_INVALID'),
        );
      }

      const data = {
        tradingInfo: {
          tradingId: editorTradingInfo.value.tradingId,
          tradingCreateUserId: editorTradingInfo.value.tradingCreateUserId,
          tradingCreateUserName: editorTradingInfo.value.tradingCreateUserName,
          tradingCreateUserIcon: editorTradingInfo.value.tradingCreateUserIcon,
          tradingCreateDate: editorTradingInfo.value.tradingCreateDate,
          tradingUpdateUserId: editorTradingInfo.value.tradingUpdateUserId,
          tradingUpdateDate: editorTradingInfo.value.tradingUpdateDate,
          tradingTrx: editorTradingInfo.value.tradingTrx,
          deleteTradingFlowIds: [],
          tradingName: formTrading.tradingName, // ここだけ更新
          tradingPatternInfo: editorTradingInfo.value.tradingPatternInfo,
          tradingFlowList: editorTradingInfo.value.tradingFlowList,
        },
      };

      const params = {
        // bff_td_10 取引管理新規登録BFF
        lslConfig: {
          serviceCode: 'tw-transaction-bff-api',
          apiCode,
          path: {
            companyId: companyId.value,
          },
        },
        data: data,
      };

      $api
        .request(params)
        .then(res => {
          root.$store.commit('END_PROCESS');
          root.$store.dispatch('SHOW_COMPLETED');
          editTradingNameMode.value = false;
          window.location.reload();
        })
        .catch(err => {
          root.$store.commit('END_PROCESS');
          if (err.response?.errors?.[0]?.code === 'ETNC0214') {
            root.$store.dispatch('SHOW_ALERT', root.$t('Message.ERROR__DATA_CONFLICT'));
          } else {
            root.$store.dispatch('SHOW_ALERT', err.message);
          }
        });
    };

    const handleColumnWidthChange = payload => {
      const { newWidth, column } = payload;
      const index = visibleSchemas.value.findIndex(
        schema => schema.key === column.property,
      );
      visibleSchemas.value[index].width = newWidth;
    };

    onMounted(() => {
      if (companyId.value) {
        getSection(FROM_TO_TYPE.FROM);
        getSection(FROM_TO_TYPE.TO);
      }
      const savedVisibleSchemas = root.$store.getters.getTableSetting(tableId);
      visibleSchemas.value =
        savedVisibleSchemas?.schemas || _.cloneDeep(tradingFlowListTableSchema);
    });

    return {
      lang,
      localSelectedTradingId,
      currentPage,
      pageSize,
      tradingFlowListFilterSchema,
      visibleSchemas,
      tradingFlowListTableSchema,
      isOpenTableSettingDialog,
      modeChangeWidth,
      canEditFlow,
      editTradingNameMode,
      formTrading,
      formComponent,
      rules,
      filterSchema,
      filteredSchemas,
      filterForm,
      filterChips,
      loading,
      tradingList,
      data,
      onApply,
      removeFilter,
      resetFilters,
      changePage,
      changeSize,
      sortChange,
      handleClickMenu,
      tsvDownLoadClick,
      handleColumnWidthChange,
      updateColumnSetting,
      rowClick,
      onCreate,
      handleSubmit,
      isFwd,
      handleCancel
    };
  },
});
</script>

<style scoped>
.draft {
  background-color: #6d717c;
  color: #fff;
  border-radius: 4px;
  padding: 2px 8px;
}
</style>
